import { render, staticRenderFns } from "./info-page1.vue?vue&type=template&id=172d020e&"
import script from "./info-page1.vue?vue&type=script&lang=js&"
export * from "./info-page1.vue?vue&type=script&lang=js&"
import style0 from "./info-page1.vue?vue&type=style&index=0&id=172d020e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports